import { useDispatch, useSelector } from 'react-redux';
import './ReportingApp.sass';
import { useEffect, useRef, useState } from 'react';
import { headerBreadcrumb } from 'src/store/UiSlice';
import { setContext } from 'src/redux/ducks/appContextSlice';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import MissionReporting from './MissionReporting/MissionReporting';

function ReportingApp() {
  const dispatch = useDispatch();
  let { path } = useRouteMatch();

  useEffect(() => {
    dispatch(headerBreadcrumb([
      {title: "Dashboard", link: "/dashboard"},
      {title: "Reporting App", link: "/dashboard/reporting-app"}
    ]))

    dispatch(
      setContext({
        theme: { color: "#2699fb", name: "reporting", highlight: "#00b93811" },
      })
    );
  }, []);

  return (
    <div className="reporting-app">
      <Switch>
        <Route path={`${path}/missions/:deviceId?/:missionId?`}>
          <MissionReporting />
        </Route>
      </Switch>
    </div>
  )
}

export default ReportingApp